import { PropsWithChildren } from "react";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import { Icon } from "#shared/icons/Icon";
import { Flex } from "#shared/view/components/Flex";
import { Stack } from "#shared/view/components/Stack";

type FieldProps = PropsWithChildren<{
  label: string;
  labelInfo?: React.ReactNode;
  error?: string;
}>;

const Field = ({ label, labelInfo, error, children }: FieldProps) => (
  <Stack gap={spacing[1]} style={{ width: "100%" }}>
    <Flex align="center" gap={spacing[1]}>
      <Text size="small" type="medium">
        {label}
      </Text>
      {labelInfo && <>{labelInfo}</>}
    </Flex>
    {children}
    {error && (
      <Flex gap={spacing[1]} align="center">
        <Icon name="infoCircle" size={12} color={colors.icon.errorDefault} />
        <Text size="tiny" color={colors.text.errorDefault}>
          {error}
        </Text>
      </Flex>
    )}
  </Stack>
);

export { Field };
